<template>
  <div class="sidebar">
    <div class="sidebar_desktop">
      <div class="sidebar__section">
        <div class="sidebar__section--nav" v-if="item === 'profile'">
          Profile
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'profile'">
          <routerLink to="/jobseeker-profile" active-class="active__link"
            >Profile</routerLink
          >
        </div>

        <div class="sidebar__section--nav" v-if="item === 'jobs'">View Available Jobs</div>
        <div class="sidebar__section--nav" v-if="item !== 'jobs'">
          <routerLink to="/jobseeker-jobs" active-class="active__link"
            >View Available Jobs</routerLink
          >
        </div>

        <div class="sidebar__section--nav" v-if="item === 'msg'">Message</div>
        <div class="sidebar__section--nav" v-if="item !== 'msg'">
          <routerLink to="/jobseeker-profile" active-class="active__link"
            >Message</routerLink
          >
        </div>
        <div class="sidebar__section--nav">
          <span @click="logOut">
            Logout
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../store/constant";

export default {
  name: "JobseekerSidebar",
  props: ["item"],
  data() {
    return {
      mobile: false
    };
  },
  methods: {
    showMobileMenu() {
      if (this.mobile) {
        this.mobile = false;
        return;
      }
      this.mobile = true;
    },
    logOut() {
      this.showMobileMenu();
      this.$store.dispatch(types.AUTH_LOGOUT).then(() => {
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  > .sidebar_desktop {
    position: fixed;
    top: 85px;
    left: 0;
    width: 200px;
    height: 100%;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 15px;
    padding-bottom: 20px;
    display: block;

    @media (max-width: 1000px) {
      display: none;
    }

    .sidebar__section {
      padding-bottom: 10px;

      .sidebar__section--nav {
        padding-bottom: 25px;
        font-size: 13px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: left;
        color: #e57414;

        > span {
          color: #000000;
          cursor: pointer;

          &:hover {
            color: #e57414;
          }
        }

        > p {
          color: #e57414;
          cursor: pointer;
          margin: 0;
        }

        .sidebar__section--nav-item {
          padding-left: 15px;

          > div {
            padding-top: 20px;
            color: #000;

            > span {
              color: #e57414;
            }
          }
        }

        a {
          color: #000;
          text-decoration: none;

          &:hover {
            color: #e57414;
          }
        }
      }
    }
  }
}
</style>
